<template>
  <div class="bag flexcz">
    <div class="bag-inner">
      <!-- <div class="deng1"></div>
      <div class="deng2"></div>
    <div class="dengguang1 blink_1"></div>
    <div class="dengguang2 blink_2"></div>
      <div class="yang"></div> -->
      <div class="bj-inner">
        <img
          src="../../img/baseImg/logo.png"
          style="height: 73px; width: 300px;"
        />
        <div
          style="
            width: 450px;
            margin-top: 5px;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
          "
        >
          <div
            v-if="global.power('index') == true"
            @click="$router.push({ path: '/home' })"
            class="s_img flexcz"
          >
            <div
              @mouseover="mouseOver($event)"
              @mouseleave="mouseLeave($event)"
              class="kg100"
            >
              <div class="kg100 flex-center">
                <div class="boxdx flex-center">
                  <svg id="stylyb2" class="icon" aria-hidden="true">
                    <use xlink:href="#icon-shujukanban"></use>
                  </svg>
                </div>
              </div>
            </div>
            <span>数据中心</span>
          </div>

          <div
            v-if="global.power('toilet') == true"
            @click="$router.push({ path: '/toiletDetail' })"
            class="s_img flexcz"
          >
            <div
              @mouseover="mouseOver($event)"
              @mouseleave="mouseLeave($event)"
              class="kg100"
            >
              <div class="kg100 flex-center">
                <div class="boxdx flex-center">
                  <svg id="stylyb2" class="icon" aria-hidden="true">
                    <use xlink:href="#icon-zhihui"></use>
                  </svg>
                </div>
              </div>
            </div>
            <span>智慧厕所</span>
          </div>
          <div
            v-if="global.power('toilet') == true"
            @click="$router.push({ path: '/toiletDetail2' })"
            class="s_img flexcz"
          >
            <div
              @mouseover="mouseOver($event)"
              @mouseleave="mouseLeave($event)"
              class="kg100"
            >
              <div class="kg100 flex-center">
                <div class="boxdx flex-center">
                  <svg id="stylyb2" class="icon" aria-hidden="true">
                    <use xlink:href="#icon-xishoujian"></use>
                  </svg>
                </div>
              </div>
            </div>
            <span>真空厕所</span>
          </div>
          <div
            @click="$router.push({ path: '/workOrder' })"
            class="s_img flexcz"
          >
            <div
              @mouseover="mouseOver($event)"
              @mouseleave="mouseLeave($event)"
              class="kg100"
            >
              <div class="kg100 flex-center">
                <div class="boxdx flex-center">
                  <svg id="stylyb2" class="icon" aria-hidden="true">
                    <use xlink:href="#icon-zhinengyunwei"></use>
                  </svg>
                </div>
              </div>
            </div>
            <span>运维管理</span>
          </div>
          <div
            @click="$router.push({ path: '/workorderSummaryReport' })"
            class="s_img flexcz"
          >
            <div
              @mouseover="mouseOver($event)"
              @mouseleave="mouseLeave($event)"
              class="kg100"
            >
              <div class="kg100 flex-center">
                <div class="boxdx flex-center">
                  <svg id="stylyb2" class="icon" aria-hidden="true">
                    <use xlink:href="#icon-baobiao"></use>
                  </svg>
                </div>
              </div>
            </div>
            <span>报表管理</span>
          </div>
          <div
            @click="$router.push({ path: '/userDetails' })"
            class="s_img flexcz"
          >
            <div
              @mouseover="mouseOver($event)"
              @mouseleave="mouseLeave($event)"
              class="kg100"
            >
              <div class="kg100 flex-center">
                <div class="boxdx flex-center">
                  <svg id="stylyb2" class="icon" aria-hidden="true">
                    <use xlink:href="#icon-xitong"></use>
                  </svg>
                </div>
              </div>
            </div>
            <span>系统管理</span>
          </div>
        </div>
      
    </div>
    </div>
  </div>
</template>


<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {
    mouseOver($event) {
      $event.currentTarget.className = "a";
      $event.currentTarget.firstElementChild.className = "kg100 flex-center b";
    },
    mouseLeave($event) {
      $event.currentTarget.className = "kg100";
      $event.currentTarget.firstElementChild.className = "kg100 flex-center";
    },
  },
  mounted() {},
  created: function () {},
};
</script>
<style scoped>
.s_img {
  height: 130px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  width: 32%;
  margin-top: 25px;
}

.icon {
  width: 35px;
  height: 35px;
  fill: #000;
}

.bag-inner span {
  color: #fff;
  margin-top: 15px;
  font-size: 25px;
}
.boxdx {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #fff;
}
.s_img span:hover {
  font-size: 30px;
}
.bag{
  background-color: rgb(194, 222, 226);
}
@keyframes b {
  0% {
    transform: rotateZ(0);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
.a {
  position: relative;
  width: 60%;
  height: 100%;
}
.b {
  transition: 0.7s;
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid #fff;
  /* 这里设置不规则边框，值可以自己随机调 */
  border-radius: 38% 62% 63% 37%/ 41% 44% 56% 59%;
  animation: b 10s infinite linear;
}
.b::after,
.b::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px #fff solid;
  transition: 0.7s;
  border-radius: 38% 62% 63% 37%/ 41% 44% 56% 59%;
  animation: b 8s infinite linear;
}
.b::before {
  animation: b 6s infinite linear;
}
.bj-inner {
  position: absolute;
  left:50%;
  transform: translateX(-50%);
  top:16.6vh;
  height: 425px;
  padding-bottom: 10px;
  padding-top: 10px;
  /* background-color: rgba(36, 40, 41, 0.4); 
  box-shadow: rgb(255, 255, 255) 0 0 18px inset;
   border-radius: 7%; */
}
/* @keyframes yang {
 from {
    left: 10px;
    bottom: 20px;
  }
 to {
    left: 1860px;
    bottom: 20px;
  }
}
.yang{
  position: absolute;
animation: yang 10s ease-in-out ;
animation-fill-mode:forwards;
 background-image: url(~@/img/baseImg/yang.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 50px;
  height: 50px;
  z-index: 10;
} */
/* .deng1{
  position: absolute;
 background-image: url(~@/img/baseImg/dD.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  top: 0;
  left: 40vw;
  width: 1.2vw;
  height: 21.6vh;
  z-index: 10;
}
.deng2{
  position: absolute;
 background-image: url(~@/img/baseImg/dD.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  top: 0;
  left: 59vw;
  width: 1.2vw;
  height: 21.6vh;
  z-index: 10;
}
.dengguang1{
  position: absolute;
 background-image: url(~@/img/baseImg/Dg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  top: 21.6vh;
  left: 37.3vw;
  width: 6.5vw;
  height: 9vh;
  z-index: 10;
}
.dengguang2{
  position: absolute;
 background-image: url(~@/img/baseImg/Dg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  top: 21.6vh;
  left: 56.4vw;
  width: 6.5vw;
  height: 9vh;
  z-index: 10;
} */
/* @keyframes blinks {
  0%,
  50%,
  100% {
    opacity: 1;
  }
  25%,
  75% {
    opacity: 0;
  }
}
@keyframes blinks1 {
  0%,
  50%,
  100% {
    opacity: 1;
  }
  25%,
  75% {
    opacity: 0;
  }
}
.blink_1 {
  animation: blinks 7s infinite;
}
.blink_2 {
  animation: blinks1 10s infinite;
} */
</style>



// WEBPACK FOOTER //
// src/pages/guide/index.vue